import { Nullable } from '../../common/domain/types/types';

export abstract class LocalFileStore {
  abstract saveBlob(folder: string, filename: string, blob: Blob): Promise<void>;

  abstract fileExists(folder: string, filename: string): Promise<boolean>;

  abstract resolveLocalUrl(folder: string, filename: string): Promise<Nullable<string>>;

  abstract releaseLocalUrl(folder: string, filename: string): void;

  abstract buildUniqueFilename(folder: string, filename: string): Promise<string>;

  abstract pruneFilesOlderThan(cutoffTimestamp: number): Promise<number>;

  abstract clearCachedFiles(): Promise<number>;
}
